import { message } from 'antd';
import { AppInsights } from "applicationinsights-js";

import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';

export function setShowall(showall) {
    return {
        type: t.SET_ACTIVITIES_SHOWALL,
        payload: showall
    };
}
export function setSelectedDetailActivityIsDirty(isdirty) {
    return {
        type: t.SET_SELECTED_DETAIL_ACTIVITY_DIRTY,
        payload: isdirty
    };
}
export function loadMyActivities() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.ACTIVITIES_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/my?lang=${lang}`);
        dispatch({
            type: t.LOAD_MY_ACTIVITIES,
            payload: resp.data
        });
        dispatch({
            type: t.ACTIVITIES_LOADING,
            payload: false
        });
    };
}

export function loadComplianceActivities(showall) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.ACTIVITIES_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities?showall=${showall}&lang=${lang}`);
        dispatch({
            type: t.LOAD_ACTIVITIES,
            payload: resp.data
        });
        dispatch({
            type: t.ACTIVITIES_LOADING,
            payload: false
        });
    };
}

export function loadDelegatedWaitingForApprovalActivities() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.ACTIVITIES_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/delegatedwaitingforapproval?lang=${lang}`);
        dispatch({
            type: t.LOAD_DELEGATED_ACTIVITIES,
            payload: resp.data
        })
    };
}
export function loadWaitingForApprovalActivities() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.ACTIVITIES_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/waitingforapproval?lang=${lang}`);
        dispatch({
            type: t.LOAD_WAITING_ACTIVITIES,
            payload: resp.data
        })
    };
}

export function clearSelectedDetailActivity() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.LOAD_ACTIVITYDETAILS,
            payload: {}
        });
    };
}

export function loadActivityDetails(idProcessingActivity) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.DETAILS_LOADING,
            payload: true
        });
        const lang = getState().uistate.appsettings.lang
        try {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/details/${idProcessingActivity}?lang=${lang}`);
            dispatch({
                type: t.LOAD_ACTIVITYDETAILS,
                payload: resp.data
            });
            dispatch({
                type: t.DETAILS_LOADING,
                payload: false
            });
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}
export function deleteActivityDetailItem(idProcessingActivity) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.delete(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/${idProcessingActivity}`);
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function createNewActivityItem(values) {
    return async (dispatch, getState) => {
        const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities`, values);
        return resp.data
    };
}

export function updateActivityDetails(activity) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.put(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities`, activity);
            message.success('data saved.');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

//#region Workflow-Actions

export function submitSelectedActivitiesForProcessing(ids) {
    return async (dispatch, getState) => {
        try {
            const activityIds = { ids };
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ProcessingActivities/startworflow`, activityIds);
            const result = resp.data; //if empty string then all ok, else show result (= errors/problems)
            return result;
        } catch (error) {
            message.error('Unexpected error submitting items.',10);
            AppInsights.trackException(error);
        }
    };
}


export function submitActivityForProcessing() {
    return async (dispatch, getState) => {
        const activity = getState()[constants.NAME].selectedDetailActivity;
        try {
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/activity/submitforprocessing/${activity.processingActivity.idProcessingActivity}`);
            const result = resp.data; //{ idReport(int) , workflowInstanceId(guid), workflowDefinitionName(string) }
            if(result){
                message.success('Workflow is started', 10);
            } else {
                message.error("Error submitting item, workflow not started.", 10);
            }
        } catch (error) {
            message.error('Unexpected error submitting item, workflow not started.',10);
            AppInsights.trackException(error);
        }
    };
}

export function rejectActivity(remark, workflowinstanceid, stepid) {
    return async (dispatch, getState) => {
        const activity = getState()[constants.NAME].selectedDetailActivity;
        try {
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/activity/reject/${activity.processingActivity.idProcessingActivity}`);
            let wfmessage = { message: remark };
            try {
                await common.wfApiClient.post(`${common.SETTINGS.REMOTERESOURCES.WF.ROOT_URL}/api/RunWorkflowTask/${workflowinstanceid}/${stepid}/`, wfmessage);
                message.success('Workflow action completed', 10);
            } catch (err) {
                AppInsights.trackException('Error on workflow action. ' + err);
                //compensate to old state...
                await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/activity/compensateforsubmiterror/${activity.processingActivity.idProcessingActivity}/${activity.processingActivity.idProcessingActivityStatus}`);
                message.error('Error submitting workflow action.');
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}
export function approveActivity(workflowinstanceid, stepid) {
    return async (dispatch, getState) => {
        const activity = getState()[constants.NAME].selectedDetailActivity;
        try {
            await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/activity/approve/${activity.processingActivity.idProcessingActivity}`);
            let wfmessage = { message: 'approved by user' };
            try {
                await common.wfApiClient.post(`${common.SETTINGS.REMOTERESOURCES.WF.ROOT_URL}/api/RunWorkflowTask/${workflowinstanceid}/${stepid}/`, wfmessage);
                message.success('Workflow action completed', 10);
            } catch (err) {
                AppInsights.trackException('Error on workflow action. ' + err);
                //compensate to old state...
                await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/compensateforsubmiterror/${activity.processingActivity.idProcessingActivity}/${activity.processingActivity.idProcessingActivityStatus}`);
                message.error('Error submitting workflow action.');
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

//#endregion
